import { render, staticRenderFns } from "./Road.vue?vue&type=template&id=877fed3a&"
import script from "./Road.vue?vue&type=script&lang=js&"
export * from "./Road.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports